import { render, staticRenderFns } from "./SearchObserver.vue?vue&type=template&id=30905034"
import script from "./SearchObserver.vue?vue&type=script&lang=js"
export * from "./SearchObserver.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports